module.exports = __webpack_public_path__ + "img/map_Z3.3.A.04.75d94c87.svg";